import React, { useEffect, useState } from 'react';
import { Table, Button, Row, Col, Input, Card, Progress, Select, Modal, Spin, Alert } from 'antd';
import { SearchOutlined, ExclamationCircleOutlined, UserSwitchOutlined } from '@ant-design/icons';
import DataDisplayWidget from 'cl-library/dist/components/shared-components/DataDisplayWidget';
import axios from 'axios';
import config from "../../config.json";
import utils from '../utils/index'
import ErrorPage from '../error-views/errorPage'
let panelIndex = -1;
let option = ''
let data = [];
let allData = [];
let saveData = {};
let responseData = [];
const { Option } = Select;
const TableData = ({ parentdata1, RMCode, onChangeHeading }) => {
  const cl = localStorage.getItem("CL");
  const token = localStorage.getItem("token");
  const [tableData, setTableData] = useState([]);
  const [alltableData, setallTableData] = useState([]);
  const [filledData, setFilledData] = useState(0);
  const [alert, setAlert] = useState(false)
  const [fillMarksAlert, setFillMarksAlert] = useState(false);
  const [fillMarksSecondAlert, setFillMarksSecondAlert] = useState(false);

  const [warningBack, setwarningBack] = useState(false);
  const [loading, setLoading] = useState(true);
  const [apiError, setapiError] = useState(null);

  let date = new Date();
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let day = ("0" + date.getDate()).slice(-2);
  let today_Date = `${year}-${month}-${day}`;

  const columns = [
    {
      title: "Token No",
      dataIndex: "Token_no",
      key: "Token_no",
      fixed: "left",
      width: '90px',
      sorter: (a, b) => utils.antdTableSorter(a, b, 'Token_no'),
    },
    {
      title: "Student Name",
      dataIndex: "Student_name",
      key: "Student_name",
      fixed: "left",
      width: '90px',
      sorter: (a, b) => utils.antdTableSorter(a, b, 'Student_name')
    },
    {
      title: "Worksheet Number",
      dataIndex: "Label",
      key: "Label",
      fixed: "left",
      width: '80px',
      sorter: (a, b) => utils.antdTableSorter(a, b, 'Label'),
      render: (_, elm, index) => elm.Label ?
        <div type='link' onClick={() => window.open(elm.Worksheet_link)} style={{ color: '#3e79f7' }}>{elm.Label}</div>
        : "No Worksheet sent"
    },
    {
      title: "Marks",
      dataIndex: "Marks",
      key: "Marks",
      fixed: "left",
      width: '70px',
      sorter: (a, b) => utils.antdTableSorter(a, b, 'Marks'),
      render: (_, elm, index) => elm.Marks ? elm.Marks : "No Marks given"
    },
    {
      title: "कैसे काम किया है?",
      dataIndex: "workBy",
      key: "workBy",
      fixed: "left",
      width: '130px',
      render: (_, elm, index) => {
        let selectElement;
        if (elm.Marks === 'आज जवाब नहीं आया' || elm.Marks === 'RM ने जबाब नहीं भरा') {
          if (elm.workBy !== "") {
            selectElement = (
              <Select style={{ width: '90%' }} onChange={selectOption} defaultValue={elm.workBy}>
                <Option value={"NR"}>NR</Option>
              </Select>
            );
          } else {
            selectElement = (
              <Select style={{ width: '90%' }} onChange={selectOption} placeholder="Option">
                <Option value={"NR"}>NR</Option>
              </Select>
            );
          }
        } else {
          if (elm.workBy !== "") {
            selectElement = (
              <Select style={{ width: '90%' }} onChange={selectOption} defaultValue={elm.workBy}>
                <Option value={"Edit"}>Edit</Option>
                <Option value={"Notebook"}>Notebook</Option>
              </Select>
            );
          } else {
            selectElement = (
              <Select style={{ width: '90%' }} onChange={selectOption} placeholder="Option">
                <Option value={"Edit"}>Edit</Option>
                <Option value={"Notebook"}>Notebook</Option>
              </Select>
            );
          }
        }

        return (
          <div style={{ width: 120, verticalAlign: 'bottom', padding: 0, margin: 0 }} onFocus={() => panelChange(elm, "workBy")}>
            {selectElement}
          </div>
        );
      }
    },
    {
      title: "किसने सेंड किया है?",
      dataIndex: "sendBy",
      key: "sendBy",
      fixed: "left",
      width: '130px',
      render: (_, elm, index) => {
        let selectOptions;

        if (elm.Marks === 'आज जवाब नहीं आया' || elm.Marks === 'RM ने जबाब नहीं भरा') {
          if (elm.sendBy !== "") {
            selectOptions = (
              <Select style={{ width: '100%' }} onChange={selectOption} defaultValue={elm.sendBy} placeholder="Option">
                <Option value={"NR"}>NR</Option>
              </Select>
            );
          } else {
            selectOptions = (
              <Select style={{ width: '100%' }} onChange={selectOption} placeholder="Option">
                <Option value={"NR"}>NR</Option>
              </Select>
            );
          }
        } else {
          if (elm.sendBy !== "") {
            selectOptions = (
              <Select style={{ width: '100%' }} onChange={selectOption} defaultValue={elm.sendBy} placeholder="Option">
                <Option value={"Student"}>Student</Option>
                <Option value={"RM"}>RM</Option>
              </Select>
            );
          } else {
            selectOptions = (
              <Select style={{ width: '100%' }} onChange={selectOption} placeholder="Option">
                <Option value={"Student"}>Student</Option>
                <Option value={"RM"}>RM</Option>
              </Select>
            );
          }
        }

        return (
          <div style={{ width: 120, verticalAlign: 'bottom', padding: 0, margin: 0 }} onFocus={() => panelChange(elm, "sendBy")}>
            {selectOptions}
          </div>
        );
      }
    },
    {
      title: "शीट और ऑडियो मैच कर रही है या नहीं ?",
      key: "sendSheet",
      dataIndex: "sendSheet",
      render: (_, elm, index) => {
        let selectOptions;

        if (elm.Marks === 'आज जवाब नहीं आया' || elm.Marks === 'RM ने जबाब नहीं भरा') {
          if (elm.sendSheet !== "") {
            selectOptions = (
              <Select style={{ width: '100%' }} onChange={selectOption} defaultValue={elm.sendSheet}>
                <Option value={"हाँ शीट भेजी थी।"}>हाँ शीट भेजी थी।</Option>
                <Option value={"नहीं शीट नहीं भेजी थी।"}>नहीं शीट नहीं भेजी थी।</Option>
              </Select>
            );
          } else {
            selectOptions = (
              <Select placeholder="Option" style={{ width: '100%' }} onChange={selectOption}>
                <Option value={"हाँ शीट भेजी थी।"}>हाँ शीट भेजी थी।</Option>
                <Option value={"नहीं शीट नहीं भेजी थी।"}>नहीं शीट नहीं भेजी थी।</Option>
              </Select>
            );
          }
        } else {
          if (elm.sendSheet !== "") {
            selectOptions = (
              <Select style={{ width: '100%' }} onChange={selectOption} defaultValue={elm.sendSheet}>
                <Option value={"हाँ स्टूडेंट ने भेजा है।"}>हाँ स्टूडेंट ने भेजा है।</Option>
                <Option value={"हाँ RM ने भेजा है।"}>हाँ RM ने भेजा है।</Option>
                <Option value={"हाँ फ़ॉर्वर्डेड लिखा है।"}>हाँ फ़ॉर्वर्डेड लिखा है।</Option>
                <Option value={"नहीं"}>नहीं</Option>
              </Select>
            );
          } else {
            selectOptions = (
              <Select placeholder="Option" style={{ width: '100%' }} onChange={selectOption}>
                <Option value={"हाँ स्टूडेंट ने भेजा है।"}>हाँ स्टूडेंट ने भेजा है।</Option>
                <Option value={"हाँ RM ने भेजा है।"}>हाँ RM ने भेजा है।</Option>
                <Option value={"हाँ फ़ॉर्वर्डेड लिखा है।"}>हाँ फ़ॉर्वर्डेड लिखा है।</Option>
                <Option value={"नहीं"}>नहीं</Option>
              </Select>
            );
          }
        }

        return (
          <div style={{ width: 230, verticalAlign: 'bottom', padding: 0, margin: 0 }} onFocus={() => panelChange(elm, "sendSheet")}>
            {selectOptions}
          </div>
        );
      }
    },
    {
      title: "RM ने msg किया या मार्क्स बताये ?",
      key: "sendMarks",
      dataIndex: "sendMarks",
      render: (_, elm, index) => {
        let selectOptions;

        if (elm.Marks === 'आज जवाब नहीं आया' || elm.Marks === 'RM ने जबाब नहीं भरा') {
          if (elm.sendMarks !== "") {
            selectOptions = (
              <Select style={{ width: '100%' }} onChange={selectOption} defaultValue={elm.sendMarks}>
                <Option value={"हाँ रिमाइंडर msg है।"}>हाँ रिमाइंडर msg है।</Option>
                <Option value={"नहीं रिमाइंडर msg नहीं है।"}>नहीं रिमाइंडर msg नहीं है।</Option>
              </Select>
            );
          } else {
            selectOptions = (
              <Select placeholder="Option" style={{ width: '100%' }} onChange={selectOption}>
                <Option value={"हाँ रिमाइंडर msg है।"}>हाँ रिमाइंडर msg है।</Option>
                <Option value={"नहीं रिमाइंडर msg नहीं है।"}>नहीं रिमाइंडर msg नहीं है।</Option>
              </Select>
            );
          }
        } else {
          if (elm.sendMarks !== "") {
            selectOptions = (
              <Select style={{ width: '100%' }} onChange={selectOption} defaultValue={elm.sendMarks}>
                <Option value={"हाँ मार्क्स बताये है।"}>हाँ मार्क्स बताये है।</Option>
                <Option value={"नहीं मार्क्स नहीं बताये।"}>नहीं मार्क्स नहीं बताये।</Option>
                <Option value={"काम नहीं आया लेकिन मार्क्स दे दिए।"}>काम नहीं आया लेकिन मार्क्स दे दिए।</Option>
              </Select>
            );
          } else {
            selectOptions = (
              <Select placeholder="Option" style={{ width: '100%' }} onChange={selectOption}>
                <Option value={"हाँ मार्क्स बताये है।"}>हाँ मार्क्स बताये है।</Option>
                <Option value={"नहीं मार्क्स नहीं बताये।"}>नहीं मार्क्स नहीं बताये।</Option>
                <Option value={"काम नहीं आया लेकिन मार्क्स दे दिए।"}>काम नहीं आया लेकिन मार्क्स दे दिए।</Option>
              </Select>
            );
          }
        }

        return (
          <div style={{ width: 210, verticalAlign: 'bottom', padding: 0, margin: 0 }} onFocus={() => panelChange(elm, "sendMarks")}>
            {selectOptions}
          </div>
        );
      }
    },
    {
      title: "मार्क्स सही बताये है ?",
      key: "sendCorrectMarks",
      dataIndex: "sendCorrectMarks",
      render: (_, elm, index) => {
        let selectOptions;
        if (elm.Marks === 'आज जवाब नहीं आया' || elm.Marks === 'RM ने जबाब नहीं भरा') {
          if (elm.sendCorrectMarks !== "") {
            selectOptions = (
              <Select style={{ width: '100%' }} onChange={selectOption} defaultValue={elm.sendCorrectMarks}>
                <Option value={"बच्चे ने काम नहीं किया है।"}>बच्चे ने काम नहीं किया है।</Option>
                <Option value={"बच्चे ने काम किया है RM ने मार्क्स भेजे हैं।"}>बच्चे ने काम किया है RM ने मार्क्स भेजे हैं।</Option>
                <Option value={"बच्चे ने काम किया है RM ने मार्क्स नहीं भेजे।"}>बच्चे ने काम किया है RM ने मार्क्स नहीं भेजे।</Option>
              </Select>
            );
          } else {
            selectOptions = (
              <Select placeholder="Option" style={{ width: '100%' }} onChange={selectOption}>
                <Option value={"बच्चे ने काम नहीं किया है।"}>बच्चे ने काम नहीं किया है।</Option>
                <Option value={"बच्चे ने काम किया है RM ने मार्क्स भेजे हैं।"}>बच्चे ने काम किया है RM ने मार्क्स भेजे हैं।</Option>
                <Option value={"बच्चे ने काम किया है RM ने मार्क्स नहीं भेजे।"}>बच्चे ने काम किया है RM ने मार्क्स नहीं भेजे।</Option>
              </Select>
            );
          }
        } else {
          if (elm.sendCorrectMarks !== "") {
            selectOptions = (
              <Select style={{ width: '100%' }} onChange={selectOption} defaultValue={elm.sendCorrectMarks}>
                <Option value={"हाँ"}>हाँ</Option>
                <Option value={"1-2 मार्क्स की गलती है।"}>1-2 मार्क्स की गलती है।</Option>
                <Option value={"काम नहीं आया लेकिन मार्क्स दे दिए।"}>काम नहीं आया लेकिन मार्क्स दे दिए।</Option>
                <Option value={"नहीं"}>नहीं</Option>
              </Select>
            );
          } else {
            selectOptions = (
              <Select placeholder="Option" style={{ width: '100%' }} onChange={selectOption}>
                <Option value={"हाँ"}>हाँ</Option>
                <Option value={"1-2 मार्क्स की गलती है।"}>1-2 मार्क्स की गलती है।</Option>
                <Option value={"काम नहीं आया लेकिन मार्क्स दे दिए।"}>काम नहीं आया लेकिन मार्क्स दे दिए।</Option>
                <Option value={"नहीं"}>नहीं</Option>
              </Select>
            );
          }
        }

        return (
          <div style={{ width: 250, verticalAlign: 'bottom', padding: 0, margin: 0, wordWrap: 'break-word', wordBreak: 'break-word' }} onFocus={() => panelChange(elm, "sendCorrectMarks")}>
            {selectOptions}
          </div>
        );
      }


    },
  ];


  useEffect(() => {
    async function fetchData() {
      let url = config.getRMEngAudit + cl + '&RMcode=' + RMCode + '&date=' + today_Date;
      await axios.get(url, { headers: { 'Authorization': token } })
        .then(resp => {
          if (resp.data.status === "error") setapiError(resp.data);
          else {
            responseData = resp.data;
          }
        }, error => {
          setapiError(error.response);
        })

      if (parentdata1.length > 0) {

        let parentAuditdata = parentdata1.map(item => (
          {
            'Token_no': item.Token_no,
            'Student_name': item.Student_name,
            'Label': item.Label,
            'Marks': item.Marks,
            'Worksheet_link': item.Worksheet_link,
            'sendSheet': '',
            'sendMarks': '',
            'sendCorrectMarks': '',
            'workBy': '',
            'sendBy': '',
            'Comment': '',

          }
        ))
        parentAuditdata.forEach((o1) => {
          let obj = responseData.find((o2) => o2.Token_no === o1.Token_no)
          if (obj) {
            o1.sendSheet = obj.send_sheets;
            o1.sendMarks = obj.RM_Send_mark_in_evening;
            o1.sendCorrectMarks = obj.RM_give_correct_marks;
            o1.workBy = obj.workBy;
            o1.sendBy = obj.sendBy;
            o1.Comment = obj.Comment
          }
        })
        setallTableData(parentAuditdata);
        setTableData(parentAuditdata);

        data = parentAuditdata;
        allData = parentAuditdata;
        setLoading(false)
      }

      let filterData = allData.filter(item => item.sendSheet !== '' && item.sendMarks !== '' && item.sendCorrectMarks !== '')
      setFilledData(filterData.length)

    }
    fetchData();
  }, [parentdata1]);

  function panelChange(value, str) {
    let index = allData.findIndex((i) => i.Token_no === value.Token_no)
    panelIndex = index;
    option = str;
  }

  const selectOption = (e) => {
    if (option === "sendSheet") {
      allData[panelIndex].sendSheet = e;
      setTableData(allData)
    }
    else if (option === "sendMarks") {
      allData[panelIndex].sendMarks = e;
      setTableData(allData)
    }
    else if (option === "sendCorrectMarks") {
      allData[panelIndex].sendCorrectMarks = e;
      setTableData(allData)
    }
    else if (option === "workBy") {
      allData[panelIndex].workBy = e;
      setTableData(allData)
    }
    else if (option === "sendBy") {
      allData[panelIndex].sendBy = e;
      setTableData(allData)
    }
    let filterData = allData.filter(item => item.sendSheet !== '' && item.sendMarks !== '' && item.sendCorrectMarks !== '' && item.workBy !== '' && item.sendBy !== '')
    setFilledData(filterData.length);

    if (allData[panelIndex].sendSheet !== '' || allData[panelIndex].sendMarks !== '' || allData[panelIndex].sendCorrectMarks !== '' || allData[panelIndex].workBy !== '' || allData[panelIndex].sendBy !== '') {
      saveData = allData[panelIndex];
      saveAudit();
    }
  }

  const saveAudit = () => {
    let url1 = config.postRMAuditEngresponse + cl + '&RMcode=' + RMCode;
    axios.post(url1, { rmData: [saveData] })
      .then(resp => {
        if (resp.data.status === "error") setapiError(resp.data);

      }, error => {
        setapiError(error.response);
      })
  }

  const submitAllParent = () => {
    if (allData.length > 40) {
      if (filledData >= 40) {
        submitAudit();
      }
      else {
        setFillMarksAlert(true)
      }
    }
    else {
      if (filledData === allData.length) {
        submitAudit();
      }
      else {
        setFillMarksSecondAlert(true)
      }
    }
  }

  const onClose = e => {
    setFillMarksAlert(false)
  };

  const onCloseOne = e => {
    setFillMarksSecondAlert(false)
  };

  function submitAudit() {
    let url2 = config.postAuditRMEngScore + cl + '&RMcode=' + RMCode;

    let finalFmAuditScore = rmAuditScoreCalc()
    let finalrmSendSheetScore = rmSendSheetScoreCalc()
    let finalSendMarkScore = rmSendMarkScoreCalc()
    let finalCorrectMarks = rmSendCorrectMarksScoreCalc()

    axios.post(url2, {
      finalFmAuditScore: finalFmAuditScore,
      finalrmSendSheetScore: finalrmSendSheetScore,
      finalSendMarkScore: finalSendMarkScore,
      finalCorrectMarks: finalCorrectMarks
    })
    setAlert(true)
    axios.post(url2, { finalFmAuditScore: finalFmAuditScore })
      .then(resp => {
        if (resp.data.status === "error") setapiError(resp.data);
        setAlert(true)
        window.location = '/omPortal/app/CentalAudit';
      }, error => {
        setapiError(error.response);
      })
  }

  const rmAuditScoreCalc = () => {
    let filterData = allData.filter(item => item.sendSheet !== '' && item.sendMarks !== '' && item.sendCorrectMarks !== '')
    let positiveScore = filterData.length * 3;

    let negativeScore = allData.reduce((acc, cur) => {
      if (cur.sendSheet === 'नहीं')
        ++acc;
      if (cur.sendSheet === 'नहीं शीट नहीं भेजी थी।')
        ++acc;
      if (cur.sendMarks === 'नहीं रिमाइंडर msg नहीं है।')
        ++acc;
      if (cur.sendMarks === 'नहीं मार्क्स नहीं बताये।')
        ++acc;
      if (cur.sendMarks === 'काम नहीं आया लेकिन मार्क्स दे दिए।')
        ++acc;
      if (cur.sendCorrectMarks === 'बच्चे ने काम किया है RM ने मार्क्स नहीं भेजे।')
        ++acc;
      if (cur.sendCorrectMarks === 'काम नहीं आया लेकिन मार्क्स दे दिए।')
        ++acc;
      if (cur.sendCorrectMarks === 'नहीं')
        ++acc;
      return acc;
    }, 0)

    let rmAuditScore = (((positiveScore - negativeScore) / positiveScore) * 100)
    return Math.round(rmAuditScore, 2)
  }

  const rmSendSheetScoreCalc = () => {
    let filterData = allData.filter(item => item.sendSheet !== '')
    let positiveScore = filterData.length * 1;

    let negativeScore = allData.reduce((acc, cur) => {
      if (cur.sendSheet === 'नहीं')
        ++acc;
      if (cur.sendSheet === 'नहीं शीट नहीं भेजी थी।')
        ++acc;
      return acc;
    }, 0)

    let rmSendSheetScoreCalc = (((positiveScore - negativeScore) / positiveScore) * 100)
    return Math.round(rmSendSheetScoreCalc, 2)
  }


  const rmSendMarkScoreCalc = () => {
    let filterData = allData.filter(item => item.sendMarks !== '')
    let positiveScore = filterData.length;

    let negativeScore = allData.reduce((acc, cur) => {
      if (cur.sendMarks === 'नहीं रिमाइंडर msg नहीं है।')
        ++acc;
      if (cur.sendMarks === 'नहीं मार्क्स नहीं बताये।')
        ++acc;
      if (cur.sendMarks === 'काम नहीं आया लेकिन मार्क्स दे दिए।')
        ++acc;
      return acc;
    }, 0)

    let rmSendMarkScoreCalc = (((positiveScore - negativeScore) / positiveScore) * 100)
    return Math.round(rmSendMarkScoreCalc, 2)
  }

  const rmSendCorrectMarksScoreCalc = () => {
    let filterData = allData.filter(item => item.sendCorrectMarks !== '')
    let positiveScore = filterData.length;

    let negativeScore = allData.reduce((acc, cur) => {
      if (cur.sendCorrectMarks === 'बच्चे ने काम किया है RM ने मार्क्स नहीं भेजे।')
        ++acc;
      if (cur.sendCorrectMarks === 'काम नहीं आया लेकिन मार्क्स दे दिए।')
        ++acc;
      if (cur.sendCorrectMarks === 'नहीं')
        ++acc;
      return acc;
    }, 0)

    let rmSendCorrectMarksScoreCalc = (((positiveScore - negativeScore) / positiveScore) * 100)
    return Math.round(rmSendCorrectMarksScoreCalc, 2)
  }

  const back = () => {
    setwarningBack(!warningBack)
  }

  function cancel(e) {
    setwarningBack(false)
    onChangeHeading();
    window.location = "/omPortal/app/CentalAudit";
  }

  const onSearch = e => {
    const value = e.currentTarget.value;
    const searchdata = utils.wildCardSearch(allData, value)
    data = searchdata;
    setTableData(searchdata);
  }

  const FilterData = (value) => {

    if (value === 'Yes') {
      let filterData = allData.filter(item => item.sendSheet !== '' || item.sendMarks !== '' || item.sendCorrectMarks !== '')
      data = filterData
      setTableData(filterData);
    }
    else if (value === 'No') {
      const data1 = utils.filterArray(allData, 'sendSheet', '')
      const data2 = utils.filterArray(data1, 'sendMarks', '')
      const data3 = utils.filterArray(data2, 'sendCorrectMarks', '')
      data = data3
      setTableData(data3);
    }
    else {
      const details = utils.filterArray(allData, 'sendSheet', '');
      data = allData
      setTableData(details);
    }
  }

  const handleChange = (e, record) => {
    let len = allData.findIndex((obj) => obj.Token_no === record.Token_no)
    allData[len].Comment = e.target.value;
    setTableData(allData)
    if (allData[len].sendSheet !== '' || allData[len].sendMarks !== '' || allData[len].sendCorrectMarks !== '' || allData[len].workBy !== '' || allData[len].sendBy !== '') {
      saveData = allData[len];
      saveAudit();
    }
  }

  const expandedRowRender = record => {
    return (<>
      {record.Comment ? <>
        Any Comments? : <Input placeholder='Enter Comment in 1000 words' onChange={e => handleChange(e, record)} value={record.Comment} />
      </>
        :
        <>
          Any Comments? : <Input placeholder='Enter Comment in 1000 words' onChange={e => handleChange(e, record)} />
        </>
      }
    </>)
  }
  if (apiError) {
    return <ErrorPage details={apiError} />
  } else if (loading) {
    return <Spin tip="Loading..."></Spin>
  }
  else {
    return (
      <div>
        <Row gutter={6}>
          <Col lg={16}>
            <Card title='Filter' style={{ height: 120 }}>
              <Row>
                <Col lg={12}>
                  <Input placeholder="Search" style={{ width: '50%', }} prefix={<SearchOutlined />} onChange={e => onSearch(e)} />
                </Col>
                <Col lg={12}>
                  <Select defaultValue={'All'} style={{ width: '50%', }} onChange={FilterData}>
                    <Option value={"All"}>All</Option>
                    <Option value={"Yes"}>Filled Data</Option>
                    <Option value={"No"}>Not filled Data</Option>
                  </Select></Col>
              </Row>
            </Card>
          </Col>
          <Col lg={4} className='text-center'>
            <Card style={{ height: 120 }}>
              <Progress
                status={filledData < 40 ? "exception" : "success"}
                percent={filledData}
                format={percent => `${percent} Audit`}
                type='circle'
                width={95}
              />
            </Card>
          </Col>
          <Col lg={4}>
            <DataDisplayWidget
              icon={<UserSwitchOutlined />}
              value={data.length}
              title="Total Student"
              color="cyan"
              size={"10"}
              vertical={true}
              avatarSize={30}
              style={{ height: 120 }}
            />
          </Col>

        </Row>
        <Card title={`RMCode : ${RMCode}`}>

          <Table
            columns={columns}
            dataSource={data}
            rowKey='Token_no'
            style={{
              overflowY: 'scroll',
              height: 600
            }}
            scroll={{ x: 1000, y: 500 }}
            pagination={false}
            expandable={{
              expandedRowRender
            }}
          />
        </Card>
        {alert === true ? <Alert
          message="Success"
          description="Today's RM Audit done Successfully!."
          type="success"
          showIcon
          details={alert}
        />
          :
          ""}
        {fillMarksAlert === true ?
          <Alert
            message={`${filledData} Student Data Filled. Please Fill atleaast 40 Student Data.`}
            type="error"
            details={fillMarksAlert}
            closable
            onClose={onClose}
          />
          :
          ""}
        {fillMarksSecondAlert === true ?
          <Alert
            message={`${filledData} Student Data Filled. Please Fill atleaast all Student Data.`}
            type="error"
            details={fillMarksAlert}
            closable
            onClose={onCloseOne}
          />
          :
          ""}
        <Card>
          <Row>
            <Col xs={8} sm={8} md={8} lg={18} xl={20} xxl={20}>
              <Button onClick={back} className='m-3' type='link'>Go Back</Button>
            </Col>
            <Col xs={16} sm={16} md={16} lg={6} xl={4} xxl={4}>
              <Button className='m-3' type='primary' onClick={submitAllParent}>Submit English Audit</Button>
            </Col>
          </Row>
        </Card>

        <Modal
          title={"Warning!!!"}
          visible={warningBack}
          okText={"नहीं"}
          cancelText={"हाँ"}
          onOk={back}
          onCancel={cancel}
          type='error'
        >
          <h3><ExclamationCircleOutlined style={{ color: "orange" }} /> क्या आप वापस जाना चाहते हो ? </h3>
          <p>अगर आप वापस गए तो आपका भरा हुआ डाटा हट जाएगा ।</p>
        </Modal>
      </div>
    )
  }
}

export default TableData